<script>
	import { getContext } from "svelte";

	const { data, xGet, yGet, zGet } = getContext("LayerCake");

	export let opacity = 1;

	$: coordinates = $data.map((group) =>
		group.values.filter((d) => $yGet(d)).map((d) => [$xGet(d), $yGet(d)])
	);
</script>

<div class="circles">
	{#each $data as group, i}
		<div
			class="circle"
			style:opacity
			style:left={coordinates[i].at(-1)[0] + "%"}
			style:top={coordinates[i].at(-1)[1] + "%"}
			style:background={$zGet(group)}
		/>
	{/each}
</div>

<style>
	.circle {
		width: 6px;
		height: 6px;
		position: absolute;
		border-radius: 50%;
		outline: 2px solid white;
		transform: translate(-50%, -50%);
		transition: opacity 0.3s ease;
	}
</style>
